import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import ListMyGroups from "../../../Components/SharedComponents/ListData/ListMyGroups";

function UserGroupListModal() {

	const { groupsOfUser } = useGeneralContext();

	return (
		<>
			<ListMyGroups 
				groupsToShow={groupsOfUser}
			/>
		</>
	)
}

export default UserGroupListModal
